module.exports = __webpack_public_path__ + "media/assets/avia/search/plane_red-384752ffc5417a3d54f017ee72f73e62.png";